import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n, { installLocaleEffects, localizeMessage, formatDate } from "./i18n";
import { translatedContent, translatedHtml, translatedPrivateContent } from "./i18n/content";


export { API_ENDPOINT } from "./config";

installLocaleEffects(router);
const app = createApp(App);
app.config.globalProperties.$message = (value) => {
  const localized = localizeMessage(value);
  return localized === value && typeof value === "string" ? translatedContent(value) : localized;
};
app.config.globalProperties.$formatDate = formatDate;
app.config.globalProperties.$content = translatedContent;
app.config.globalProperties.$contentHtml = translatedHtml;
app.config.globalProperties.$privateContent = translatedPrivateContent;
app.use(router).use(i18n).mount("#app");
